/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectPatternPathsQuery } from '../../models/get-project-pattern-paths-query';
import { GetProjectPatternPathsQueryResult } from '../../models/get-project-pattern-paths-query-result';

export interface ApiProjectStagesGetPatternPathsPost$Plain$Params {
      body?: GetProjectPatternPathsQuery
}

export function apiProjectStagesGetPatternPathsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectStagesGetPatternPathsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPatternPathsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectStagesGetPatternPathsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectPatternPathsQueryResult>;
    })
  );
}

apiProjectStagesGetPatternPathsPost$Plain.PATH = '/api/ProjectStages/GetPatternPaths';
